import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mx-auto mb-6">
          <i className="ri-error-warning-line text-4xl" aria-hidden="true" />
        </div>
        <h1 className="font-heading text-6xl font-bold text-foreground-900 mb-2">404</h1>
        <h2 className="font-heading text-2xl font-semibold text-foreground-700 mb-4">Page Not Found</h2>
        <p className="text-foreground-500 text-base leading-relaxed mb-8">
          Sorry, the page you are looking for doesn&apos;t exist or has been moved. Let&apos;s get you back to our community.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary">
            <i className="ri-home-line" aria-hidden="true" />
            Back to Home
          </Link>
          <Link to="/contact" className="btn-outline">
            <i className="ri-mail-line" aria-hidden="true" />
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}